import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-16 sm:py-24 bg-white" data-id="element-212">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-214">
          <p className="text-teal-700 font-bold text-sm uppercase tracking-wide mb-4" data-id="element-215">
            LA SOLUCIÓN
          </p>

          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6" data-id="element-216">
            KIT CLÍNICO COGNITIVO™
          </h2>

          <p className="text-2xl text-gray-700 mb-8 font-medium" data-id="element-217">
            El sistema completo de intervención cognitiva para profesionales de
            la salud
          </p>

          <p className="text-lg text-gray-600 mb-8" data-id="element-218">
            Sin buscar en internet. Sin adaptar material de otros países. Sin
            improvisar.
          </p>

          <p className="text-lg text-gray-700 mb-8" data-id="element-219">
            300 fichas técnicas imprimibles, organizadas por nivel de deterioro
            y rango etario, listas para usar desde el primer día. Pensado para
            la realidad del consultorio argentino.
          </p>

          <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-r-lg mb-8" data-id="element-220">
            <p className="text-lg text-gray-700 italic" data-id="element-221">
              El tiempo que perdés preparando material no es tiempo que le
              dedicás a tus pacientes. Es tiempo que te robás a vos misma.
            </p>
          </div>

          <blockquote className="bg-gradient-to-r from-amber-50 to-amber-100 p-8 rounded-lg shadow-md border-l-4 border-amber-500" data-id="element-222">
            <p className="text-xl text-gray-800 italic mb-4" data-id="element-223">
              "Diseñé este sistema para que el profesional llegue al consultorio
              a hacer clínica, no a hacer artesanías."
            </p>
          </blockquote>
        </motion.div>
      </div>
    </section>;
}